import { render, staticRenderFns } from "./GroupPlanForm.vue?vue&type=template&id=a39c049a&scoped=true&lang=pug"
import script from "./GroupPlanForm.vue?vue&type=script&lang=js"
export * from "./GroupPlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39c049a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GroupSelect: require('/home/docker/code/frontend/components/GroupSelect.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default,UploadFilesForm: require('/home/docker/code/frontend/components/UploadFilesForm.vue').default})
